import React from "react";
import { MdCheck } from "react-icons/md";

interface FlowPanelProps {
  step: number;
  title: string;
  /** Wybrana wartość pokazywana po prawej w nagłówku (data, godzina). */
  value?: string;
  done?: boolean;
  locked?: boolean;
  /** Komunikat w zablokowanej kolumnie – mówi, czego brakuje. */
  lockedMessage?: string;
  className?: string;
  /** Przyklejone do dołu panelu (np. powtórzona data). */
  footer?: React.ReactNode;
  children?: React.ReactNode;
}

const FlowPanel: React.FC<FlowPanelProps> = ({
  step,
  title,
  value,
  done = false,
  locked = false,
  lockedMessage,
  className = "",
  footer,
  children,
}) => (
  <section
    className={`flow-col${locked ? " flow-col--locked" : ""}${done ? " flow-col--done" : ""} ${className}`.trim()}
    aria-label={title}
  >
    <div className="flow-panel">
      <header className="flow-panel__head">
        <span className="flow-panel__num" aria-hidden={true}>
          {done ? <MdCheck /> : step}
        </span>
        <h2 className="flow-panel__title">{title}</h2>
        {value && <span className="flow-panel__value">{value}</span>}
      </header>

      {locked && lockedMessage && !children ? (
        <p className="flow-panel__locked-msg">{lockedMessage}</p>
      ) : (
        <div className="flow-panel__body">{children}</div>
      )}

      {footer && <div className="flow-panel__footer">{footer}</div>}
    </div>
  </section>
);

export default FlowPanel;
